export default __webpack_public_path__ + "static/media/writing-white.4c72ff9a.png";